import type { GroupData, GroupFormData, MemberData } from "shared/schema";
import { type AsyncValueCallback, getRandom } from "shelving";
import { useStore } from "shelving/react";
import { CheckboxField, Field, Form, FormCondition, HueField, MediaField, TextAreaField, TextField, useFormContext } from "shared/react";
import { GROUP_FORM_SCHEMA, canGroupHaveUsername } from "shared/schema";
import { useItem } from "../util/db.js";
import { uploadMediaFile } from "../util/media.js";
import { USER } from "../util/user.js";
import { RawGroupCard } from "./GroupCard.js";

export function GroupForm({ data, children, onSubmit }: { data?: Partial<GroupData> | undefined; children: React.ReactNode; onSubmit: AsyncValueCallback<GroupFormData> }): React.ReactElement {
	const { name, username } = useItem("profile", USER.data.uid).data;
	return (
		<Form
			schema={GROUP_FORM_SCHEMA}
			onSubmit={onSubmit}
			data={{
				hue: getRandom(0, 360),
				name: `${name || `@${username}`}'s group`,
				members: 1,
				...data,
			}}
		>
			<GroupFormCard />
			<Field title="Details">
				<TextField name="name" />
				<div className="flex-row flex-stretch gap-hairline">
					<TextField name="location" />
					<TextField name="website" />
				</div>
			</Field>
			<TextAreaField name="about" />
			{data ? <TextField name="username" disabled={!canGroupHaveUsername(data)} /> : null}
			<div>
				<div className="flex-row flex-stretch gap-hairline space-hairline">
					<MediaField name="photo" uploader={uploadMediaFile} mods="flex-half" />
					<MediaField name="cover" uploader={uploadMediaFile} mods="flex-half" />
				</div>
				<div className="field">
					<HueField name="hue" />
				</div>
			</div>
			<CheckboxField name="open" />
			<FormCondition<GroupData> onChange={({ open = false }) => open}>
				<CheckboxField name="approval" />
			</FormCondition>
			{children}
		</Form>
	);
}

function GroupFormCard(): React.ReactElement {
	const form = useStore(useFormContext());
	return (
		<div
			onClick={e => {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}}
		>
			<RawGroupCard group={form.data as GroupData} member={{ status: "owner" } as MemberData} />
		</div>
	);
}
